
import { formatDistanceToNow } from "date-fns";

type FeedbackCommentProps = {
  content: string;
  createdAt: string;
  submitterName?: string | null;
};

const FeedbackComment = ({ content, createdAt, submitterName }: FeedbackCommentProps) => {
  return (
    <div className="border-b border-border py-4 last:border-0">
      <div className="flex items-start justify-between mb-2">
        <span className="font-medium text-sm">
          {submitterName || "Anonymous"}
        </span>
        <span className="text-xs text-muted-foreground">
          {formatDistanceToNow(new Date(createdAt), { addSuffix: true })}
        </span>
      </div>
      <p className="text-sm text-muted-foreground">{content}</p>
    </div>
  );
};

export default FeedbackComment;
